module.exports = __webpack_public_path__ + "static/img/limit_white_07.340e3f52.svg";